import {
	LikeIdsResponse,
	SetResponseDto
} from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

export const likeKeys = {
	base: ['like'] as const,
	all: (setId: SetResponseDto['id'] = 'without-set') =>
		[...likeKeys.base, 'all', setId] as const,
	ids: () => [...likeKeys.base, 'ids'] as const,

	/**
	 * Mutations
	 */
	create: () => [...likeKeys.base, 'create'] as const,
	update: () => [...likeKeys.base, 'update'] as const,
	delete: () => [...likeKeys.base, 'delete'] as const
}

export interface LikeTypes {
	all: Offer[]
	ids: LikeIdsResponse
}

export interface LikeKeys {
	all: ReturnType<typeof likeKeys.all>
	ids: ReturnType<typeof likeKeys.ids>
}
